import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eye, EyeOff, Trophy, Clock, Play, Hand, ShieldAlert, Moon, Sun, UserX, Crown, Lock, X, CheckCircle2, LogOut, Settings } from 'lucide-react';
import confetti from 'canvas-confetti';
import './App.css';

const DEFAULT_BACKEND_URL = 'https://stop-backend.eds456roblox.workers.dev';
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || DEFAULT_BACKEND_URL).replace(/\/+$/, '');
const WS_URL = process.env.REACT_APP_WS_URL || `${BACKEND_URL.replace(/^http/, 'ws')}/ws/`;
const GOOGLE_CLIENT_ID = '54474722474-2remt75946g91b1pqr532itid3lu4v5c.apps.googleusercontent.com';
const GOOGLE_STORAGE_KEY = 'stop_google_auth';
const LANG_STORAGE_KEY = 'stop_lang';

const CATEGORY_KEYS = ['Country', 'Brand', 'Names', 'Animals', 'Objects', 'Cities'];
const MAX_FREE_PLAYS = 4;
const SUPPORTED_LANGS = new Set(['pt', 'en', 'de']);

// --- DICIONÁRIO DE TRADUÇÕES ---
const translations = {
  pt: {
    title: "STOP_", profile: "O Teu Nome", profilePlaceholder: "NinjaGamer99", createRoom: "Criar Sala",
    rounds: "Rondas", seconds: "Segundos", passwordOpt: "Password", newGameBtn: "Nova Partida",
    joinRoom: "Entrar em Sala", codePlaceholder: "Código (ex: AB12)", passwordReq: "Password da Sala",
    joinBtn: "Entrar no Jogo", room: "SALA", players: "Lutadores", waitingHost: "A aguardar que o Host inicie...",
    startBtn: "COMEÇAR!", round: "RONDA", turnOf: "Vez de:", waitAction: "A aguardar ação...",
    letterIs: "A Letra é", submitBtn: "SUBMETER RESPOSTAS!", locked: "TRANCADO!",
    waitingOthers: "A aguardar os adversários...", forceEnd: "Forçar Fim (Host)", results: "RESULTADOS",
    validation_title: "Validar Respostas",
    validation_subtitle: "Marca as respostas dos outros jogadores como válidas ou inválidas.",
    validation_submit: "Submeter Validação",
    validation_waiting: "A aguardar validação dos restantes jogadores...",
    validation_progress: "Progresso da validação",
    validation_pending: "pendente",
    validation_valid: "Válida",
    validation_invalid: "Inválida",
    validation_no_answers: "Sem respostas para validar.",
    validation_for_player: "Respostas de",
    evalOf: "Avaliação de", total: "Total", globalRank: "CLASSIFICAÇÃO GLOBAL", nextRound: "Avançar para Próxima Ronda",
    seeWinner: "Ver Vencedor Final", endGame: "FIM DE JOGO", supremeWinner: "VENCEDOR SUPREMO", pts: "pts",
    backMenu: "Voltar ao Menu", errorName: "Insere o teu nome!", errorFill: "Preenche os dados!",
    errorConn: "Falha na ligação ao servidor.", kickBtn: "Expulsar",
    err_room_not_found: "Sala não encontrada!", err_game_started: "O jogo já começou!", 
    err_wrong_pass: "Password incorreta!", kicked_msg: "Foste expulso da sala pelo Host!",
    pro_title: "TORNA-TE PRO!", pro_subtitle: "Esmagaste o limite grátis ou queres recursos premium?",
    pro_feat1: "Jogos Ilimitados (Sem limite de 4/dia)", pro_feat2: "Escolhe sala PÚBLICA ou PRIVADA ao criar", pro_feat3: "Emblema PRO no chat e na sala",
    pro_btn_monthly: "Mês", pro_btn_lifetime: "Life-Time", pro_loading: "A redirecionar...", pro_locked: "Apenas PRO", free_plays: "Jogos Hoje",
    google_login_needed: "Faz login com Google para sincronizar conta e compras.",
    google_signin_failed: "Falha no login Google. Tenta novamente.",
    google_script_failed: "Não foi possível carregar o Google Login.",
    google_signout: "Sair",
    google_signin_cta: "Entrar com Google",
    room_visibility_label: "Visibilidade da Sala",
    room_visibility_private: "Privada",
    room_visibility_public: "Pública (Lista PRO)",
    public_rooms_title: "Salas Públicas Ativas",
    public_rooms_subtitle: "Entra diretamente em salas públicas em andamento.",
    public_rooms_refresh: "Atualizar",
    public_room_players: "jogadores",
    public_room_join: "Entrar",
    public_rooms_empty: "Sem salas públicas ativas de momento.",
    public_rooms_pro_only: "A lista de salas públicas é exclusiva para PRO.",
    chat_title: "Chat da Sala",
    chat_placeholder: "Escreve uma mensagem...",
    chat_send: "Enviar",
    terms_open: "Termos",
    terms_title: "Termos e Serviços (MVP)",
    terms_intro: "Este é um resumo rápido dos termos para compras e uso da plataforma.",
    terms_purchase: "Compras: ao adquirir PRO concordas com cobrança conforme plano escolhido.",
    terms_refunds: "Reembolsos: pedidos devem ser feitos com email da conta e comprovativo de pagamento.",
    terms_reports: "Denúncias: comportamentos abusivos podem levar a suspensão de conta/sala.",
    terms_contact: "Suporte: contacta a equipa para análise de pagamentos e denúncias.",
    account_settings: "Definições da Conta",
    account_plan: "Plano Atual",
    account_plan_pro: "PRO",
    account_plan_free: "FREE",
    account_email: "Email",
    account_name: "Nome",
    account_manage_billing: "Gerir Billing / Cancelar",
    account_billing_loading: "A abrir portal de billing...",
    account_settings_open: "Abrir definições",
    account_no_google: "Liga a conta Google para gerir billing.",
    account_help: "No portal da Stripe podes cancelar cobranças futuras.",
    cat_Country: "País", cat_Brand: "Marca", cat_Names: "Nome", cat_Animals: "Animal", cat_Objects: "Objeto", cat_Cities: "Cidade"
  },
  en: {
    title: "STOP_", profile: "Your Name", profilePlaceholder: "NinjaGamer99", createRoom: "Create Room",
    rounds: "Rounds", seconds: "Seconds", passwordOpt: "Password", newGameBtn: "New Game",
    joinRoom: "Join Room", codePlaceholder: "Code (e.g. AB12)", passwordReq: "Room Password",
    joinBtn: "Join Game", room: "ROOM", players: "Fighters", waitingHost: "Waiting for Host to start...",
    startBtn: "START!", round: "ROUND", turnOf: "Turn of:", waitAction: "Waiting for action...",
    letterIs: "The Letter is", submitBtn: "SUBMIT ANSWERS!", locked: "LOCKED!",
    waitingOthers: "Waiting for opponents...", forceEnd: "Force End (Host)", results: "RESULTS",
    validation_title: "Validate Answers",
    validation_subtitle: "Mark other players' answers as valid or invalid.",
    validation_submit: "Submit Validation",
    validation_waiting: "Waiting for the remaining players to validate...",
    validation_progress: "Validation progress",
    validation_pending: "pending",
    validation_valid: "Valid",
    validation_invalid: "Invalid",
    validation_no_answers: "No answers to validate.",
    validation_for_player: "Answers from",
    evalOf: "Evaluation of", total: "Total", globalRank: "GLOBAL RANKING", nextRound: "Next Round",
    seeWinner: "See Final Winner", endGame: "GAME OVER", supremeWinner: "SUPREME WINNER", pts: "pts",
    backMenu: "Back to Menu", errorName: "Enter your name!", errorFill: "Fill in the details!",
    errorConn: "Connection to server failed.", kickBtn: "Kick",
    err_room_not_found: "Room not found!", err_game_started: "Game has already started!", 
    err_wrong_pass: "Incorrect password!", kicked_msg: "You were kicked by the Host!",
    pro_title: "BECOME PRO!", pro_subtitle: "Hit the free limit or want premium features?",
    pro_feat1: "Unlimited Games (No 4/day limit)", pro_feat2: "Choose PUBLIC or PRIVATE room when creating", pro_feat3: "PRO badge in chat and lobby",
    pro_btn_monthly: "Month", pro_btn_lifetime: "Life-Time", pro_loading: "Redirecting...", pro_locked: "PRO Only", free_plays: "Plays Today",
    google_login_needed: "Sign in with Google to sync your account and purchases.",
    google_signin_failed: "Google sign in failed. Please try again.",
    google_script_failed: "Google Login could not be loaded.",
    google_signout: "Sign out",
    google_signin_cta: "Sign in with Google",
    room_visibility_label: "Room Visibility",
    room_visibility_private: "Private",
    room_visibility_public: "Public (PRO List)",
    public_rooms_title: "Active Public Rooms",
    public_rooms_subtitle: "Join public rooms that are currently running.",
    public_rooms_refresh: "Refresh",
    public_room_players: "players",
    public_room_join: "Join",
    public_rooms_empty: "No active public rooms right now.",
    public_rooms_pro_only: "Public room list is a PRO-only feature.",
    chat_title: "Room Chat",
    chat_placeholder: "Type a message...",
    chat_send: "Send",
    terms_open: "Terms",
    terms_title: "Terms & Services (MVP)",
    terms_intro: "This is a quick summary for purchases and platform usage.",
    terms_purchase: "Purchases: by buying PRO you agree to charges based on selected plan.",
    terms_refunds: "Refunds: requests must include account email and payment proof.",
    terms_reports: "Reports: abusive behavior may result in account/room suspension.",
    terms_contact: "Support: contact the team for payment and reports analysis.",
    account_settings: "Account Settings",
    account_plan: "Current Plan",
    account_plan_pro: "PRO",
    account_plan_free: "FREE",
    account_email: "Email",
    account_name: "Name",
    account_manage_billing: "Manage Billing / Cancel",
    account_billing_loading: "Opening billing portal...",
    account_settings_open: "Open settings",
    account_no_google: "Connect Google account to manage billing.",
    account_help: "You can cancel future payments in Stripe portal.",
    cat_Country: "Country", cat_Brand: "Brand", cat_Names: "Name", cat_Animals: "Animal", cat_Objects: "Object", cat_Cities: "City"
  },
  de: {
    title: "STOP_", profile: "Dein Name", profilePlaceholder: "NinjaGamer99", createRoom: "Raum Erstellen",
    rounds: "Runden", seconds: "Sekunden", passwordOpt: "Passwort", newGameBtn: "Neues Spiel",
    joinRoom: "Raum Betreten", codePlaceholder: "Code (z.B. AB12)", passwordReq: "Raum Passwort",
    joinBtn: "Spiel Beitreten", room: "RAUM", players: "Kämpfer", waitingHost: "Warten auf den Host...",
    startBtn: "STARTEN!", round: "RUNDE", turnOf: "Am Zug:", waitAction: "Warten auf Aktion...",
    letterIs: "Der Buchstabe ist", submitBtn: "ANTWORTEN SENDEN!", locked: "GESPERRT!",
    waitingOthers: "Warten auf Gegner...", forceEnd: "Ende Erzwingen (Host)", results: "ERGEBNISSE",
    validation_title: "Antworten validieren",
    validation_subtitle: "Markiere Antworten anderer Spieler als gültig oder ungültig.",
    validation_submit: "Validierung senden",
    validation_waiting: "Warten auf Validierung der anderen Spieler...",
    validation_progress: "Validierungsfortschritt",
    validation_pending: "ausstehend",
    validation_valid: "Gültig",
    validation_invalid: "Ungültig",
    validation_no_answers: "Keine Antworten zum Validieren.",
    validation_for_player: "Antworten von",
    evalOf: "Bewertung von", total: "Gesamt", globalRank: "GLOBALE RANGLISTE", nextRound: "Nächste Runde",
    seeWinner: "Sieger ansehen", endGame: "SPIEL ENDE", supremeWinner: "GEWINNER", pts: "Pkt",
    backMenu: "Zurück zum Menü", errorName: "Gib deinen Namen ein!", errorFill: "Fülle die Details aus!",
    errorConn: "Verbindung zum Server fehlgeschlagen.", kickBtn: "Kicken",
    err_room_not_found: "Raum nicht gefunden!", err_game_started: "Spiel hat bereits begonnen!", 
    err_wrong_pass: "Falsches Passwort!", kicked_msg: "Du wurdest vom Host gekickt!",
    pro_title: "WERDE PRO!", pro_subtitle: "Freies Limit erreicht oder Premium gesucht?",
    pro_feat1: "Unbegrenzte Spiele (Kein 4/Tag Limit)", pro_feat2: "Wähle beim Erstellen ÖFFENTLICH oder PRIVAT", pro_feat3: "PRO-Badge in Chat und Lobby",
    pro_btn_monthly: "Monat", pro_btn_lifetime: "Life-Time", pro_loading: "Umleiten...", pro_locked: "Nur PRO", free_plays: "Spiele Heute",
    google_login_needed: "Melde dich mit Google an, um Konto und Käufe zu synchronisieren.",
    google_signin_failed: "Google-Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
    google_script_failed: "Google Login konnte nicht geladen werden.",
    google_signout: "Abmelden",
    google_signin_cta: "Mit Google anmelden",
    room_visibility_label: "Raum-Sichtbarkeit",
    room_visibility_private: "Privat",
    room_visibility_public: "Öffentlich (PRO-Liste)",
    public_rooms_title: "Aktive Öffentliche Räume",
    public_rooms_subtitle: "Tritt direkt laufenden öffentlichen Räumen bei.",
    public_rooms_refresh: "Aktualisieren",
    public_room_players: "Spieler",
    public_room_join: "Beitreten",
    public_rooms_empty: "Aktuell keine öffentlichen Räume aktiv.",
    public_rooms_pro_only: "Die Liste öffentlicher Räume ist nur für PRO.",
    chat_title: "Raum-Chat",
    chat_placeholder: "Nachricht schreiben...",
    chat_send: "Senden",
    terms_open: "AGB",
    terms_title: "AGB & Dienste (MVP)",
    terms_intro: "Dies ist eine kurze Zusammenfassung zu Käufen und Nutzung der Plattform.",
    terms_purchase: "Käufe: mit PRO-Kauf stimmst du der Abrechnung des gewählten Plans zu.",
    terms_refunds: "Rückerstattungen: Anfragen benötigen Konto-E-Mail und Zahlungsnachweis.",
    terms_reports: "Meldungen: missbräuchliches Verhalten kann zur Sperre führen.",
    terms_contact: "Support: kontaktiere das Team für Prüfungen zu Zahlungen und Meldungen.",
    account_settings: "Kontoeinstellungen",
    account_plan: "Aktueller Plan",
    account_plan_pro: "PRO",
    account_plan_free: "FREE",
    account_email: "E-Mail",
    account_name: "Name",
    account_manage_billing: "Billing Verwalten / Kündigen",
    account_billing_loading: "Billing-Portal wird geöffnet...",
    account_settings_open: "Einstellungen öffnen",
    account_no_google: "Verbinde dein Google-Konto, um Billing zu verwalten.",
    account_help: "Im Stripe-Portal kannst du zukünftige Zahlungen kündigen.",
    cat_Country: "Land", cat_Brand: "Marke", cat_Names: "Name", cat_Animals: "Tier", cat_Objects: "Objekt", cat_Cities: "Stadt"
  }
};

function generateRoomCode() { return Math.random().toString(36).substring(2, 6).toUpperCase(); }

const getStoredGoogleAuth = () => {
  try {
    const raw = localStorage.getItem(GOOGLE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.idToken || !parsed?.email) return null;
    return parsed;
  } catch {
    return null;
  }
};

const saveGoogleAuth = (auth) => {
  localStorage.setItem(GOOGLE_STORAGE_KEY, JSON.stringify(auth));
};

const clearGoogleAuth = () => {
  localStorage.removeItem(GOOGLE_STORAGE_KEY);
};

const normalizeLanguage = (value) => {
  const candidate = typeof value === 'string' ? value.toLowerCase().trim() : '';
  return SUPPORTED_LANGS.has(candidate) ? candidate : null;
};

const getInitialLanguage = () => {
  const localLang = normalizeLanguage(localStorage.getItem(LANG_STORAGE_KEY));
  if (localLang) return localLang;
  const storedAuth = getStoredGoogleAuth();
  const authLang = normalizeLanguage(storedAuth?.lang);
  return authLang || 'pt';
};

const createEmptyAnswers = () =>
  CATEGORY_KEYS.reduce((acc, cat) => {
    acc[cat] = '';
    return acc;
  }, {});

const extractServerValidationVotes = (roomData, playerId) => {
  if (!roomData || !playerId) return null;
  const votes = roomData?.validations?.[playerId];
  if (!votes || typeof votes !== 'object') return null;
  return votes;
};

// --- COMPONENTES AUXILIARES ---
const MechaMascot = ({ isFocused, isPeeking }) => {
  const handVariants = { idle: { y: 0, x: 0, rotate: 0 }, blind: { y: -85, x: [0, 20], rotate: -15, transition: { type: "spring", stiffness: 300, damping: 20 } }, peek: { y: -50, x: 25, rotate: -5, transition: { type: "spring", stiffness: 300, damping: 20 } } };
  const eyeVariants = { idle: { scaleY: 1 }, blind: { scaleY: 0.1 }, peek: { scaleY: 1.5 } };
  return (
    <div className="mascot-wrapper">
      <motion.svg viewBox="0 0 300 200" className="mascot-svg" initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ type: "spring", bounce: 0.5 }}>
        <polygon points="60,80 30,20 100,60" fill="var(--primary)" stroke="var(--shadow-color)" strokeWidth="6" strokeLinejoin="round"/>
        <polygon points="240,80 270,20 200,60" fill="var(--primary)" stroke="var(--shadow-color)" strokeWidth="6" strokeLinejoin="round"/>
        <line x1="150" y1="50" x2="150" y2="10" stroke="var(--shadow-color)" strokeWidth="6" strokeLinecap="round"/>
        <circle cx="150" cy="10" r="10" fill="var(--warning)" stroke="var(--shadow-color)" strokeWidth="4"/>
        <rect x="50" y="50" width="200" height="140" rx="60" fill="var(--bg-card)" stroke="var(--shadow-color)" strokeWidth="8"/>
        <rect x="70" y="70" width="160" height="80" rx="30" fill="var(--shadow-color)" />
        <motion.ellipse cx="110" cy="110" rx="15" ry="25" fill="var(--success)" variants={eyeVariants} animate={isFocused && !isPeeking ? "blind" : (isFocused && isPeeking ? "peek" : "idle")} />
        <motion.ellipse cx="190" cy="110" rx="15" ry="25" fill="var(--success)" variants={eyeVariants} animate={isFocused ? "blind" : "idle"} />
        <motion.g variants={handVariants} animate={isFocused && !isPeeking ? "blind" : (isFocused && isPeeking ? "peek" : "idle")} style={{ originX: "50px", originY: "180px" }}>
          <rect x="30" y="150" width="60" height="40" rx="20" fill="var(--primary)" stroke="var(--shadow-color)" strokeWidth="6"/>
        </motion.g>
        <motion.g variants={handVariants} animate={isFocused ? "blind" : "idle"} style={{ originX: "250px", originY: "180px" }} custom={-1}>
          <rect x="210" y="150" width="60" height="40" rx="20" fill="var(--primary)" stroke="var(--shadow-color)" strokeWidth="6"/>
        </motion.g>
      </motion.svg>
    </div>
  );
};

const PlayerAvatar = ({ picture, name }) => {
  if (picture) {
    return <img src={picture} alt={name || 'avatar'} className="player-avatar" referrerPolicy="no-referrer" />;
  }
  const initial = (name || '?').charAt(0).toUpperCase();
  return <div className="player-avatar player-avatar-fallback">{initial}</div>;
};

const ResultsReveal = ({ room, isHost, nextRound, t }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const players = room.players;
  useEffect(() => {
    if (currentIndex < players.length) { const timer = setTimeout(() => setCurrentIndex(prev => prev + 1), 3000); return () => clearTimeout(timer); }
    else { setTimeout(() => setShowLeaderboard(true), 1000); }
  }, [currentIndex, players.length]);

  if (showLeaderboard) {
    const leaderboard = [...players].sort((a, b) => b.score - a.score);
    return (
      <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} className="card mt">
        <h2 className="header-title" style={{textAlign: 'center', marginBottom: '30px'}}>{t('globalRank')}</h2>
        <div className="flex-col">
          {leaderboard.map((p, index) => (
            <motion.div key={p.id} initial={{ x: -50, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ delay: index * 0.1, type: "spring" }} className={`leaderboard-row rank-${index + 1}`}>
              <span><span style={{marginRight: '15px', fontWeight: 900}}>#{index + 1}</span>{p.name}</span>
              <span>{p.score} <span style={{fontSize: '0.8em'}}>{t('pts').toUpperCase()}</span></span>
            </motion.div>
          ))}
        </div>
        {isHost && (<motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={nextRound} className="btn btn-primary btn-full" style={{marginTop: '40px'}}>{room.currentRound >= room.settings.rounds ? t('seeWinner') : t('nextRound')}</motion.button>)}
      </motion.div>
    );
  }

  const currentPlayer = players[currentIndex];
  if (!currentPlayer) return null;
  const resultData = room.results[currentPlayer.id];
  return (
    <motion.div key={currentPlayer.id} initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -50 }} className="card">
      <h2 className="header-title" style={{textAlign: 'center', color: 'var(--primary)', marginBottom: '30px'}}>{t('evalOf')} {currentPlayer.name}</h2>
      <div className="table-responsive">
        <table className="results-table">
          <thead><tr>{CATEGORY_KEYS.map(cat => <th key={cat}>{t(`cat_${cat}`)}</th>)}<th>{t('total')}</th></tr></thead>
          <tbody>
            <tr>
              {CATEGORY_KEYS.map((cat, idx) => {
                const ans = resultData.categories[cat];
                return (
                  <motion.td key={cat} initial={{ opacity: 0, scale: 0 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: idx * 0.3, type: "spring" }}>
                    {ans.answer || '—'}
                    {ans.score > 0 && <span className={`score-badge score-${ans.score}`}>+{ans.score}</span>}
                    {ans.answer && ans.score === 0 && <span className="score-badge score-0">0</span>}
                  </motion.td>
                );
              })}
              <motion.td initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: CATEGORY_KEYS.length * 0.3 }} style={{color: 'var(--primary)', fontSize: '1.5rem'}}>+{resultData.totalRoundScore}</motion.td>
            </tr>
          </tbody>
        </table>
      </div>
    </motion.div>
  );
};

const GameEndScreen = ({ room, t }) => {
  const winner = [...room.players].sort((a, b) => b.score - a.score)[0];
  useEffect(() => {
    const duration = 3000; const end = Date.now() + duration;
    const frame = () => { confetti({ particleCount: 5, angle: 60, spread: 55, origin: { x: 0 }, colors: ['#ff477e', '#4361ee', '#ffd166'] }); confetti({ particleCount: 5, angle: 120, spread: 55, origin: { x: 1 }, colors: ['#ff477e', '#4361ee', '#ffd166'] }); if (Date.now() < end) requestAnimationFrame(frame); };
    frame();
  }, []);
  return (
    <div className="container center-screen">
      <h2 className="title" style={{marginBottom: '0'}}>{t('endGame')}</h2>
      <motion.div initial={{ scale: 0, rotate: -10 }} animate={{ scale: 1, rotate: 0 }} transition={{ type: "spring", damping: 10 }} className="card" style={{textAlign: 'center', marginTop: '40px'}}>
        <Trophy size={80} color="var(--warning)" style={{margin: '0 auto 20px', filter: 'drop-shadow(4px 4px 0px var(--shadow-color))'}} />
        <h3 className="header-title" style={{fontSize: '1.5rem'}}>{t('supremeWinner')}</h3>
        <h1 className="title" style={{fontSize: 'clamp(3rem, 10vw, 5rem)', marginTop: '10px'}}>{winner.name}</h1>
        <hr/>
        <div className="flex-col" style={{textAlign: 'left'}}>
          {[...room.players].sort((a, b) => b.score - a.score).map((p, i) => (
            <div key={p.id} className={`leaderboard-row rank-${i + 1}`}>
              <span>#{i + 1} {p.name}</span><span>{p.score} {t('pts')}</span>
            </div>
          ))}
        </div>
        <button onClick={() => window.location.reload()} className="btn btn-secondary btn-full" style={{marginTop: '40px', padding: '20px'}}>{t('backMenu')}</button>
      </motion.div>
    </div>
  );
};

// --- APLICAÇÃO PRINCIPAL ---
function App() {
  const [lang, setLang] = useState(getInitialLanguage);
  const [theme, setTheme] = useState('dark');
  const t = (key) => translations[lang][key] || key;

  // ESTADOS GLOBAIS
  const [isPro, setIsPro] = useState(false);
  const [dailyPlays, setDailyPlays] = useState(0);
  const [showProModal, setShowProModal] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
  const [isBillingPortalLoading, setIsBillingPortalLoading] = useState(false);
  const [playerName, setPlayerName] = useState('');
  const [rounds, setRounds] = useState(3);
  const [timerSettings, setTimerSettings] = useState(60);
  const [createPassword, setCreatePassword] = useState('');
  const [roomVisibility, setRoomVisibility] = useState('private');
  const [roomIdInput, setRoomIdInput] = useState('');
  const [joinPassword, setJoinPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [focusedField, setFocusedField] = useState('none');
  
  const [room, setRoom] = useState(null);
  const [error, setError] = useState('');
  const [sessionId, setSessionId] = useState(null);
  const [answers, setAnswers] = useState(createEmptyAnswers);
  const [revealedLetter, setRevealedLetter] = useState(null);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [validationVotes, setValidationVotes] = useState({});
  const [hasSubmittedValidation, setHasSubmittedValidation] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [reactions, setReactions] = useState([]);
  const [publicRooms, setPublicRooms] = useState([]);
  const [isPublicRoomsLoading, setIsPublicRoomsLoading] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [googleProfile, setGoogleProfile] = useState(null);
  const [googleIdToken, setGoogleIdToken] = useState('');
  const [isGoogleReady, setIsGoogleReady] = useState(false);
  
  const answersRef = useRef(answers);
  const ws = useRef(null);
  const googleButtonRef = useRef(null);
  const chatEndRef = useRef(null);
  const lastSyncedLangRef = useRef(null);

  const syncGoogleProfile = async (idToken) => {
    const res = await fetch(`${BACKEND_URL}/auth/google`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ idToken, lang })
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.error || t('google_signin_failed'));
    }

    const profile = {
      email: data.email,
      name: data.name || data.email?.split('@')[0] || 'Player',
      picture: data.picture || ''
    };
    const serverLang = normalizeLanguage(data.lang);
    const resolvedLang = serverLang || lang;

    setGoogleIdToken(idToken);
    setGoogleProfile(profile);
    setIsPro(Boolean(data.isPro));
    setPlayerName((prev) => prev || profile.name);
    if (serverLang && serverLang !== lang) {
      setLang(serverLang);
    }
    lastSyncedLangRef.current = resolvedLang;
    localStorage.setItem(LANG_STORAGE_KEY, resolvedLang);

    saveGoogleAuth({ ...profile, idToken, lang: resolvedLang });
    return profile;
  };

  const logoutGoogle = () => {
    clearGoogleAuth();
    setGoogleIdToken('');
    setGoogleProfile(null);
    setIsPro(false);
    setPublicRooms([]);
    setShowAccountModal(false);
    setIsBillingPortalLoading(false);
    if (window.google?.accounts?.id) {
      window.google.accounts.id.disableAutoSelect();
    }
  };

  useEffect(() => { answersRef.current = answers; }, [answers]);
  useEffect(() => { return () => { if (ws.current) ws.current.close(); }; }, []);
  useEffect(() => {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  }, [lang]);

  useEffect(() => {
    if (!googleIdToken) return;
    if (lastSyncedLangRef.current === lang) return;

    let cancelled = false;
    const syncLanguagePreference = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/user/preferences`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ idToken: googleIdToken, lang })
        });
        const data = await res.json();
        if (!res.ok) return;

        const persistedLang = normalizeLanguage(data?.lang) || lang;
        if (cancelled) return;
        lastSyncedLangRef.current = persistedLang;
        if (googleProfile) {
          saveGoogleAuth({ ...googleProfile, idToken: googleIdToken, lang: persistedLang });
        }
      } catch {
        // noop
      }
    };

    syncLanguagePreference();
    return () => { cancelled = true; };
  }, [lang, googleIdToken, googleProfile]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('success') !== 'true') return;

    const sessionId = params.get('session_id');
    const stored = getStoredGoogleAuth();
    const storedToken = stored?.idToken;

    const confirmCheckout = async () => {
      try {
        if (!storedToken) {
          throw new Error(t('google_login_needed'));
        }

        if (sessionId) {
          const res = await fetch(`${BACKEND_URL}/confirm-checkout-session`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ idToken: storedToken, sessionId })
          });
          const data = await res.json();

          if (!res.ok && res.status !== 202) {
            if (res.status === 401) logoutGoogle();
            throw new Error(data.error || 'Erro ao confirmar pagamento');
          }

          if (data.isPro) {
            setIsPro(true);
            confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 } });
          } else {
            await syncGoogleProfile(storedToken);
          }
        } else {
          await syncGoogleProfile(storedToken);
        }
      } catch (error) {
        setError(error.message || 'Falha ao confirmar pagamento.');
      } finally {
        window.history.replaceState(null, '', window.location.pathname);
      }
    };

    confirmCheckout();
  }, []);

  useEffect(() => {
    const stored = getStoredGoogleAuth();
    if (!stored?.idToken) return;

    setGoogleIdToken(stored.idToken);
    setGoogleProfile({
      email: stored.email,
      name: stored.name,
      picture: stored.picture
    });
    setPlayerName((prev) => prev || stored.name || '');

    syncGoogleProfile(stored.idToken).catch(() => {
      clearGoogleAuth();
      setGoogleIdToken('');
      setGoogleProfile(null);
    });
  }, []);

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    const today = new Date().toDateString();
    const storedDate = localStorage.getItem('stop_date');
    if (storedDate !== today) {
      localStorage.setItem('stop_date', today);
      localStorage.setItem('stop_plays', '0');
      setDailyPlays(0);
    } else {
      setDailyPlays(parseInt(localStorage.getItem('stop_plays') || '0'));
    }
  }, [theme]);

  useEffect(() => {
    if (room) {
      setPublicRooms([]);
      return;
    }

    fetchPublicRooms();
    const timer = setInterval(fetchPublicRooms, 10000);
    return () => clearInterval(timer);
  }, [room]);

  useEffect(() => {
    let cancelled = false;

    const initGoogleSignIn = () => {
      if (cancelled || !window.google?.accounts?.id || !googleButtonRef.current) return;

      googleButtonRef.current.innerHTML = '';
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        auto_select: true,
        callback: async (response) => {
          if (!response?.credential) return;
          try {
            await syncGoogleProfile(response.credential);
          } catch (error) {
            setError(error.message || t('google_signin_failed'));
          }
        }
      });
      window.google.accounts.id.renderButton(googleButtonRef.current, {
        type: 'standard',
        theme: theme === 'dark' ? 'filled_black' : 'outline',
        size: 'large',
        shape: 'pill',
        text: 'signin_with',
        width: 270
      });
      setIsGoogleReady(true);
    };

    if (window.google?.accounts?.id) {
      initGoogleSignIn();
      return () => { cancelled = true; };
    }

    const existingScript = document.getElementById('google-identity-services');
    if (existingScript) {
      existingScript.addEventListener('load', initGoogleSignIn, { once: true });
      return () => { cancelled = true; };
    }

    const script = document.createElement('script');
    script.id = 'google-identity-services';
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = initGoogleSignIn;
    script.onerror = () => setError(t('google_script_failed'));
    document.head.appendChild(script);

    return () => { cancelled = true; };
  }, [theme, googleProfile]);

  useEffect(() => {
    let interval;
    if (room?.state === 'answering' && !hasSubmitted) {
      const maxTime = room.settings.timer || 60;
      setTimeLeft(maxTime);
      interval = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            ws.current.send(JSON.stringify({ type: 'submit_answers', data: { answers: answersRef.current } }));
            setHasSubmitted(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [room?.state, room?.settings?.timer, hasSubmitted]);

  const checkoutStripe = async (plan) => {
    setIsCheckoutLoading(true);
    try {
      if (!googleIdToken) {
        throw new Error(t('google_login_needed'));
      }

      const res = await fetch(`${BACKEND_URL}/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ idToken: googleIdToken, plan })
      });
      const data = await res.json();
      if (!res.ok || !data.url) {
        if (res.status === 401) logoutGoogle();
        throw new Error(data.error || 'Erro ao criar checkout');
      }
      window.location.href = data.url;
    } catch (error) {
      setError(error.message || 'Erro ao contactar o servidor de pagamento.');
      setIsCheckoutLoading(false);
    }
  };

  const openBillingPortal = async () => {
    setIsBillingPortalLoading(true);
    try {
      if (!googleIdToken) {
        throw new Error(t('account_no_google'));
      }

      const res = await fetch(`${BACKEND_URL}/create-billing-portal-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ idToken: googleIdToken })
      });
      const data = await res.json();
      if (!res.ok || !data.url) {
        if (res.status === 401) logoutGoogle();
        throw new Error(data.error || 'Erro ao abrir portal de billing');
      }

      window.location.href = data.url;
    } catch (error) {
      setError(error.message || 'Erro ao abrir billing.');
      setIsBillingPortalLoading(false);
    }
  };

  const fetchPublicRooms = async () => {
    setIsPublicRoomsLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/public-rooms`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Erro ao listar salas públicas');
      setPublicRooms(Array.isArray(data.rooms) ? data.rooms : []);
    } catch (error) {
      setError(error.message || 'Erro ao listar salas públicas.');
    } finally {
      setIsPublicRoomsLoading(false);
    }
  };

  const registerPlay = () => {
    if (!isPro) {
      const newPlays = dailyPlays + 1;
      setDailyPlays(newPlays);
      localStorage.setItem('stop_plays', newPlays.toString());
    }
  };

  const connectWebSocket = (roomId, isHost, passwordPayload, visibilityPayload = 'private') => {
    const socket = new WebSocket(WS_URL + roomId);
    const displayName = playerName.trim() || googleProfile?.name || 'Player';
    const profilePayload = {
      name: displayName,
      email: googleProfile?.email || '',
      picture: googleProfile?.picture || '',
      idToken: googleIdToken || ''
    };

    socket.onopen = () => {
      setChatMessages([]);
      setChatInput('');
      setValidationVotes({});
      setHasSubmittedValidation(false);
      registerPlay(); 
      if (isHost) {
        socket.send(JSON.stringify({
          type: 'create_room',
          data: { roomId, rounds, timer: timerSettings, password: passwordPayload, visibility: visibilityPayload, ...profilePayload }
        }));
      } else {
        socket.send(JSON.stringify({
          type: 'join_room',
          data: { password: passwordPayload, ...profilePayload }
        }));
      }
    };
    socket.onmessage = (event) => {
      const { type, data } = JSON.parse(event.data);
      if (type === 'pro_status') {
        setIsPro(data.isPro);
      }
      else if (type === 'room_updated') {
        setRoom(data);
        if (data.state === 'spinning') {
          setRevealedLetter(null);
          setHasSubmitted(false);
          setAnswers(createEmptyAnswers());
          setValidationVotes({});
          setHasSubmittedValidation(false);
        }
        const me = data.players.find((p) => (
          googleProfile?.email ? p.email === googleProfile.email : p.name === displayName
        ));
        if (me && !sessionId) setSessionId(me.id);
        const resolvedSessionId = me?.id || sessionId;
        if (data.state === 'validating' && resolvedSessionId) {
          const serverVotes = extractServerValidationVotes(data, resolvedSessionId);
          if (serverVotes) {
            setValidationVotes(serverVotes);
            setHasSubmittedValidation(true);
          }
        }
      } 
      else if (type === 'reveal_letter') {
        setRevealedLetter(data.letter);
        setRoom(data.roomState);
        setValidationVotes({});
        setHasSubmittedValidation(false);
      } 
      else if (type === 'show_results') {
        setRoom(data);
      } 
      else if (type === 'chat_history') {
        setChatMessages(Array.isArray(data?.messages) ? data.messages : []);
      }
      else if (type === 'chat_message') {
        if (data?.message) {
          setChatMessages(prev => [...prev, data.message].slice(-100));
        }
      }
      else if (type === 'reaction') {
        const id = Date.now() + Math.random();
        setReactions(prev => [...prev, { id, emoji: data.emoji }]);
        setTimeout(() => setReactions(prev => prev.filter(r => r.id !== id)), 2000);
      }
      else if (type === 'kicked') { setRoom(null); setChatMessages([]); setChatInput(''); setError(t('kicked_msg')); if (ws.current) ws.current.close(); }
      else if (type === 'error') { setError(t(data) || data); setTimeout(() => setError(''), 3000); }
    };
    socket.onerror = () => setError(t('errorConn'));
    ws.current = socket;
  };

  const attemptPlay = (action) => {
    if (!playerName.trim()) return setError(t('errorName'));
    if (!isPro && dailyPlays >= MAX_FREE_PLAYS) { setShowProModal(true); return; }
    action();
  };

  const createRoom = () => attemptPlay(() => {
    const finalVisibility = isPro ? roomVisibility : 'private';
    const finalPassword = finalVisibility === 'private' && isPro ? createPassword : '';
    connectWebSocket(generateRoomCode(), true, finalPassword, finalVisibility);
  });
  const joinRoom = () => {
    if (!roomIdInput.trim()) return setError(t('errorFill'));
    attemptPlay(() => connectWebSocket(roomIdInput.toUpperCase(), false, joinPassword));
  };
  const joinPublicRoom = (publicRoomId) => {
    if (!publicRoomId) return;
    attemptPlay(() => connectWebSocket(String(publicRoomId).toUpperCase(), false, ''));
  };

  const sendReaction = (emoji) => { if (ws.current && room) ws.current.send(JSON.stringify({ type: 'send_reaction', data: { emoji } })); };
  const sendChatMessage = () => {
    const text = chatInput.trim();
    if (!text || !ws.current || !room) return;
    ws.current.send(JSON.stringify({ type: 'send_chat', data: { text } }));
    setChatInput('');
  };

  const updateValidationVote = (targetId, category, vote) => {
    setValidationVotes((prev) => ({
      ...prev,
      [targetId]: {
        ...(prev[targetId] || {}),
        [category]: vote
      }
    }));
  };

  const submitValidation = () => {
    if (!ws.current || !room || room.state !== 'validating') return;
    ws.current.send(JSON.stringify({ type: 'submit_validation', data: { votes: validationVotes } }));
    setHasSubmittedValidation(true);
  };

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chatMessages]);

  const renderReactions = () => (
    <AnimatePresence>
      {reactions.map(r => (
        <motion.div key={r.id} initial={{ y: 0, opacity: 1, scale: 0.5, x: Math.random() * 100 - 50 }} animate={{ y: -300, opacity: 0, scale: 2 }} transition={{ duration: 2, ease: "easeOut" }} className="floating-emoji" style={{ left: `${Math.random() * 60 + 20}vw` }}>{r.emoji}</motion.div>
      ))}
    </AnimatePresence>
  );

  const renderReactionControls = () => {
    if (!room || room.state === 'end') return null;
    return (
      <div className="reactions-bar">
        <button className="reaction-btn" onClick={() => sendReaction('🍅')}>🍅</button>
        <button className="reaction-btn" onClick={() => sendReaction('💥')}>💥</button>
        <button className="reaction-btn" onClick={() => sendReaction('💩')}>💩</button>
        <button className="reaction-btn" onClick={() => sendReaction('🤡')}>🤡</button>
      </div>
    );
  };

  const renderPublicRooms = () => {
    return (
      <div className="card public-rooms-card">
        <div className="public-room-header">
          <div>
            <h3 className="header-title" style={{fontSize: '1.4rem'}}>{t('public_rooms_title')}</h3>
            <p className="public-room-subtitle">{t('public_rooms_subtitle')}</p>
          </div>
          <button type="button" className="btn btn-secondary public-room-refresh" onClick={fetchPublicRooms} disabled={isPublicRoomsLoading}>
            {t('public_rooms_refresh')}
          </button>
        </div>

        <div className="public-room-list">
          {publicRooms.length === 0 && (
            <p className="public-room-empty">
              {isPublicRoomsLoading ? t('public_rooms_refresh') : t('public_rooms_empty')}
            </p>
          )}

          {publicRooms.map((publicRoom) => (
            <div key={publicRoom.id} className="public-room-item">
              <div>
                <strong>{publicRoom.id}</strong>
                <p>{publicRoom.playersCount} {t('public_room_players')} - {publicRoom.state}</p>
              </div>
              <button type="button" className="btn btn-primary public-room-join" onClick={() => joinPublicRoom(publicRoom.id)}>
                {t('public_room_join')}
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderChatPanel = () => {
    if (!room) return null;

    return (
      <div className="chat-panel">
        <div className="chat-header">{t('chat_title')}</div>
        <div className="chat-messages">
          {chatMessages.map((msg) => (
            <div key={msg.id} className="chat-message">
              <PlayerAvatar picture={msg.picture} name={msg.name} />
              <div className="chat-bubble">
                <div className="chat-meta">
                  <strong>{msg.name}</strong>
                  {msg.isPro && <span className="chat-pro"><Crown size={12} /> PRO</span>}
                </div>
                <p>{msg.text}</p>
              </div>
            </div>
          ))}
          <div ref={chatEndRef} />
        </div>
        <div className="chat-input-row">
          <input
            type="text"
            className="input-field chat-input"
            value={chatInput}
            onChange={(e) => setChatInput(e.target.value)}
            placeholder={t('chat_placeholder')}
            onKeyDown={(e) => {
              if (e.key === 'Enter') sendChatMessage();
            }}
            maxLength={220}
          />
          <button type="button" className="btn btn-secondary chat-send" onClick={sendChatMessage}>
            {t('chat_send')}
          </button>
        </div>
      </div>
    );
  };

  const isHost = room?.hostId === sessionId;
  const currentPlayer = room?.players[room?.currentTurnIndex] || room?.players[0];
  const isMyTurn = currentPlayer && currentPlayer.id === sessionId;
  const maxTime = room?.settings?.timer || 60;
  const isCriticalTime = room?.state === 'answering' && !hasSubmitted && timeLeft <= 10;
  const validationTargets = room?.state === 'validating' && sessionId
    ? room.players
      .filter((player) => player.id !== sessionId)
      .map((player) => ({
        ...player,
        entries: CATEGORY_KEYS
          .map((cat) => ({
            category: cat,
            answer: room.answers?.[player.id]?.[cat] || ''
          }))
          .filter((entry) => entry.answer.trim().length > 0)
      }))
      .filter((player) => player.entries.length > 0)
    : [];
  const totalValidationRequired = validationTargets.reduce((acc, player) => acc + player.entries.length, 0);
  const totalValidationDone = validationTargets.reduce((acc, player) => {
    const doneForPlayer = player.entries.filter((entry) => {
      return typeof validationVotes?.[player.id]?.[entry.category] === 'boolean';
    }).length;
    return acc + doneForPlayer;
  }, 0);
  const isValidationReadyToSubmit = totalValidationRequired === 0 || totalValidationDone === totalValidationRequired;
  const validationProgress = room?.validationProgress;
  const pendingValidationNames = (validationProgress?.players || [])
    .filter((player) => !player.done)
    .map((player) => player.name);

  if (!room) {
    return (
      <div className="container center-screen" style={{paddingTop: '20px'}}>
        
        {/* MODAIS DE CONTA E PRO */}
        <AnimatePresence>
          {showAccountModal && googleProfile && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="modal-overlay" onClick={() => !isBillingPortalLoading && setShowAccountModal(false)}>
              <motion.div initial={{ scale: 0.8, y: 50 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.8, y: 50 }} className="modal-content settings-modal" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={() => setShowAccountModal(false)}><X size={30}/></button>
                <h2 className="header-title settings-title">{t('account_settings')}</h2>
                <p className="settings-help">{t('account_help')}</p>

                <div className="settings-user-card">
                  <PlayerAvatar picture={googleProfile.picture} name={googleProfile.name} />
                  <div className="settings-user-meta">
                    <strong>{googleProfile.name}</strong>
                    <span>{googleProfile.email}</span>
                  </div>
                </div>

                <div className="settings-grid">
                  <div className="settings-item">
                    <span>{t('account_name')}</span>
                    <strong>{googleProfile.name}</strong>
                  </div>
                  <div className="settings-item">
                    <span>{t('account_email')}</span>
                    <strong>{googleProfile.email}</strong>
                  </div>
                  <div className="settings-item">
                    <span>{t('account_plan')}</span>
                    <strong>{isPro ? t('account_plan_pro') : t('account_plan_free')}</strong>
                  </div>
                  <div className="settings-item">
                    <span>{t('free_plays')}</span>
                    <strong>{dailyPlays}/{MAX_FREE_PLAYS}</strong>
                  </div>
                </div>

                <button className="btn btn-secondary btn-full" onClick={openBillingPortal} disabled={!googleIdToken || isBillingPortalLoading}>
                  {isBillingPortalLoading ? t('account_billing_loading') : t('account_manage_billing')}
                </button>
              </motion.div>
            </motion.div>
          )}

          {showTermsModal && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="modal-overlay" onClick={() => setShowTermsModal(false)}>
              <motion.div initial={{ scale: 0.8, y: 50 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.8, y: 50 }} className="modal-content settings-modal" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={() => setShowTermsModal(false)}><X size={30}/></button>
                <h2 className="header-title settings-title">{t('terms_title')}</h2>
                <p className="settings-help">{t('terms_intro')}</p>
                <div className="settings-grid">
                  <div className="settings-item"><strong>{t('terms_purchase')}</strong></div>
                  <div className="settings-item"><strong>{t('terms_refunds')}</strong></div>
                  <div className="settings-item"><strong>{t('terms_reports')}</strong></div>
                  <div className="settings-item"><strong>{t('terms_contact')}</strong></div>
                </div>
              </motion.div>
            </motion.div>
          )}

          {showProModal && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="modal-overlay" onClick={() => !isCheckoutLoading && setShowProModal(false)}>
              <motion.div initial={{ scale: 0.8, y: 50 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.8, y: 50 }} className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={() => setShowProModal(false)}><X size={30}/></button>
                <Crown size={60} color="var(--warning)" style={{margin: '0 auto 20px', filter: 'drop-shadow(2px 2px 0 var(--shadow-color))'}} />
                <h2 className="title" style={{fontSize: '2.5rem', marginBottom: '10px'}}>{t('pro_title')}</h2>
                <p style={{fontSize: '1.2rem', color: 'var(--text-muted)'}}>{t('pro_subtitle')}</p>
                <div className="pro-feature-list">
                  <div className="pro-feature-item"><CheckCircle2 color="var(--success)"/> {t('pro_feat1')}</div>
                  <div className="pro-feature-item"><CheckCircle2 color="var(--success)"/> {t('pro_feat2')}</div>
                  <div className="pro-feature-item"><CheckCircle2 color="var(--success)"/> {t('pro_feat3')}</div>
                </div>
                {!googleProfile && (
                  <div className="google-required">{t('google_login_needed')}</div>
                )}
                
                {isCheckoutLoading ? (
                   <button className="btn btn-vip btn-full" style={{fontSize: '1.3rem'}} disabled>{t('pro_loading')}</button>
                ) : (
                  <div className="pricing-buttons">
                    <button className="btn btn-vip btn-price" onClick={() => checkoutStripe('monthly')} disabled={!googleIdToken}>
                      <span className="price-val">4.99€</span>
                      <span className="price-label">/ {t('pro_btn_monthly')}</span>
                    </button>
                    <button className="btn btn-primary btn-price" onClick={() => checkoutStripe('lifetime')} disabled={!googleIdToken}>
                      <span className="price-val">50€</span>
                      <span className="price-label">{t('pro_btn_lifetime')}</span>
                    </button>
                  </div>
                )}
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="top-controls">
          {isPro ? (
            <div className="vip-badge"><Crown size={20}/> PRO</div>
          ) : (
            <div className="vip-badge" style={{background: 'var(--bg-card)', color: 'var(--text-muted)', borderStyle: 'dashed', cursor: 'pointer'}} onClick={() => setShowProModal(true)}>
              {t('free_plays')}: {dailyPlays}/{MAX_FREE_PLAYS}
            </div>
          )}
          <div className="controls-right">
            {googleProfile ? (
              <div className="account-chip">
                <PlayerAvatar picture={googleProfile.picture} name={googleProfile.name} />
                <span className="account-name">{googleProfile.name}</span>
                <button type="button" className="account-settings" onClick={() => setShowAccountModal(true)} title={t('account_settings_open')}>
                  <Settings size={16} />
                </button>
                <button type="button" className="account-logout" onClick={logoutGoogle} title={t('google_signout')}>
                  <LogOut size={16} />
                </button>
              </div>
            ) : (
              <div className="google-signin-wrap">
                <div ref={googleButtonRef} />
                {!isGoogleReady && <span className="google-hint">{t('google_signin_cta')}</span>}
              </div>
            )}
            <button type="button" className="btn btn-secondary mini-btn" onClick={() => setShowTermsModal(true)}>
              {t('terms_open')}
            </button>
            <select className="lang-select" value={lang} onChange={(e) => setLang(e.target.value)}>
              <option value="pt">PT</option><option value="en">EN</option><option value="de">DE</option>
            </select>
            <button className="icon-btn" onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}>
              {theme === 'light' ? <Moon size={24} /> : <Sun size={24} />}
            </button>
          </div>
        </div>

        <h1 className="title">{t('title')}</h1>
        <MechaMascot isFocused={focusedField === 'pass'} isPeeking={showPassword} />
        
        <motion.div initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="card">
          <AnimatePresence>{error && <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="error"><ShieldAlert size={20} style={{display:'inline', marginRight:'10px'}}/>{error}</motion.div>}</AnimatePresence>
          <div className="flex-col">
            <label className="input-label">{t('profile')}</label>
            <input type="text" placeholder={t('profilePlaceholder')} value={playerName} onChange={e => setPlayerName(e.target.value)} onFocus={() => setFocusedField('none')} className="input-field mb" />
          </div>
          <hr/>
          <div className="flex-col">
            <label className="input-label">{t('createRoom')}</label>
            <div style={{display: 'flex', gap: '15px', marginBottom: '15px'}}>
              <input type="number" min="1" max="10" placeholder={t('rounds')} value={rounds} onChange={e => setRounds(e.target.value)} onFocus={() => setFocusedField('none')} className="input-field" />
              <input type="number" min="10" max="300" placeholder={t('seconds')} value={timerSettings} onChange={e => setTimerSettings(e.target.value)} onFocus={() => setFocusedField('none')} className="input-field" />
            </div>
            {isPro && (
              <div className="flex-col" style={{marginBottom: '8px'}}>
                <label className="input-label">{t('room_visibility_label')}</label>
                <select className="input-field" value={roomVisibility} onChange={(e) => setRoomVisibility(e.target.value)}>
                  <option value="private">{t('room_visibility_private')}</option>
                  <option value="public">{t('room_visibility_public')}</option>
                </select>
              </div>
            )}
            {(roomVisibility === 'private' || !isPro) && (
              <div className={`password-wrapper mb ${!isPro ? 'locked' : ''}`} onClick={() => !isPro && setShowProModal(true)}>
                <input type={showPassword ? "text" : "password"} placeholder={isPro ? t('passwordOpt') : t('pro_locked')} value={createPassword} onChange={e => setCreatePassword(e.target.value)} onFocus={() => isPro && setFocusedField('pass')} onBlur={() => setFocusedField('none')} disabled={!isPro} className="input-field" />
                {!isPro ? <Lock className="lock-icon" size={24} /> : <button type="button" className="eye-button" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeOff size={20}/> : <Eye size={20}/>}</button>}
              </div>
            )}
            <button onClick={createRoom} className="btn btn-primary mb"><Play fill="#fff" size={20} /> {t('newGameBtn')}</button>
          </div>
          <hr/>
          <div className="flex-col">
            <label className="input-label">{t('joinRoom')}</label>
            <input type="text" placeholder={t('codePlaceholder')} value={roomIdInput} onChange={e => setRoomIdInput(e.target.value)} onFocus={() => setFocusedField('none')} className="input-field mb" style={{textTransform: 'uppercase'}} />
            <div className="password-wrapper mb">
              <input type={showPassword ? "text" : "password"} placeholder={t('passwordReq')} value={joinPassword} onChange={e => setJoinPassword(e.target.value)} onFocus={() => setFocusedField('pass')} onBlur={() => setFocusedField('none')} className="input-field" />
              <button type="button" className="eye-button" onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeOff size={20}/> : <Eye size={20}/>}</button>
            </div>
            <button onClick={joinRoom} className="btn btn-secondary">{t('joinBtn')}</button>
          </div>
        </motion.div>
        {renderPublicRooms()}
      </div>
    );
  }

  return (
    <>
      {renderReactions()}
      {renderReactionControls()}
      {renderChatPanel()}
      
      {room.state === 'lobby' && (
        <div className="container">
          <h2 className="title">{t('room')} {room.id}</h2>
          <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} className="card">
            <div style={{display: 'flex', gap: '20px', marginBottom: '30px', justifyContent: 'center', flexWrap: 'wrap'}}>
              <span className="score-badge score-10" style={{fontSize: '1.2rem', padding: '10px 20px'}}><Trophy size={20} style={{marginRight: '10px'}}/> {room.settings.rounds} {t('rounds')}</span>
              <span className="score-badge score-5" style={{fontSize: '1.2rem', padding: '10px 20px'}}><Clock size={20} style={{marginRight: '10px'}}/> {room.settings.timer}s</span>
            </div>
            <h3 className="header-title" style={{fontSize: '1.5rem', marginBottom: '20px'}}>{t('players')} ({room.players.length})</h3>
            <div className="flex-col">
              <AnimatePresence>
                {room.players.map((p) => (
                  <motion.div key={p.id} initial={{ x: -50, opacity: 0 }} animate={{ x: 0, opacity: 1 }} exit={{ x: 50, opacity: 0 }} className="input-field player-lobby-row">
                    <div className="player-info">
                      <PlayerAvatar picture={p.picture} name={p.name} />
                      <span>{p.name}</span>
                      {p.isPro && <span className="chat-pro"><Crown size={12} /> PRO</span>}
                      {p.id === room.hostId && <span style={{color: 'var(--primary)', fontWeight: 900}}>HOST</span>}
                    </div>
                    {isHost && p.id !== sessionId && (
                      <button className="btn-kick" onClick={() => ws.current.send(JSON.stringify({ type: 'kick_player', data: { targetId: p.id } }))}><UserX size={16} /> {t('kickBtn')}</button>
                    )}
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>
            {isHost ? (
              <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => ws.current.send(JSON.stringify({ type: 'start_game' }))} className="btn btn-primary btn-full" style={{marginTop: '40px', fontSize: '1.5rem', padding: '20px'}}>{t('startBtn')}</motion.button>
            ) : (
              <div className="input-field mt" style={{textAlign: 'center', background: 'var(--bg-main)', color: 'var(--text-muted)'}}>{t('waitingHost')}</div>
            )}
          </motion.div>
        </div>
      )}

      {room.state === 'spinning' && (
        <div className="container center-screen">
          <h2 className="title" style={{fontSize: 'clamp(2rem, 6vw, 3rem)'}}>{t('round')} {room.currentRound} / {room.settings.rounds}</h2>
          <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: "spring", damping: 12 }} className="spinning-area">
            <div className="slot-machine-box">
              <motion.div animate={{ y: [0, -200, 200, 0] }} transition={{ repeat: Infinity, duration: 0.2, ease: "linear" }} className="slot-letter">?</motion.div>
            </div>
            <p style={{fontSize: '1.5rem', fontWeight: 900, color: 'var(--text-main)', marginTop: '30px', textTransform: 'uppercase'}}>
              {t('turnOf')} <span style={{color: 'var(--primary)'}}>{currentPlayer?.name}</span>
            </p>
            {isMyTurn ? (
              <motion.button whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} onClick={() => ws.current.send(JSON.stringify({ type: 'stop_letter' }))} className="btn btn-danger mt" style={{marginTop: '50px'}}><Hand size={40} style={{display:'inline', verticalAlign:'middle', marginRight:'15px'}}/> STOP!</motion.button>
            ) : (
              <p className="mt" style={{fontSize: '1.2rem', fontWeight: 800, color: 'var(--text-muted)', marginTop: '40px'}}>{t('waitAction')}</p>
            )}
          </motion.div>
        </div>
      )}

      {room.state === 'answering' && (
        <div className="container-wide">
          {!hasSubmitted && (
            <motion.div animate={isCriticalTime ? { scale: [1, 1.05, 1], rotate: [0, -1, 1, 0] } : {}} transition={{ repeat: isCriticalTime ? Infinity : 0, duration: 0.3 }} className="timer-bar-wrapper">
              <div className="timer-bar-fill" style={{ width: `${(timeLeft / maxTime) * 100}%`, background: isCriticalTime ? 'var(--danger)' : 'var(--success)' }}></div>
              <div className="timer-text-overlay">{Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}</div>
            </motion.div>
          )}
          <div className="header" style={{marginBottom: '0'}}>
            <h2 className="title" style={{fontSize: 'clamp(2rem, 6vw, 3rem)'}}>{t('letterIs')}</h2>
            <motion.div initial={{ scale: 5, opacity: 0, rotate: -180 }} animate={{ scale: 1, opacity: 1, rotate: 0 }} transition={{ type: "spring", damping: 10 }} className="highlight-letter">{revealedLetter}</motion.div>
          </div>
          {!hasSubmitted ? (
            <div className="card grid-answers" style={{marginTop: '30px'}}>
              {CATEGORY_KEYS.map((cat, index) => (
                <motion.div key={cat} initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.05 }} className="flex-col" style={{gap: '5px'}}>
                  <label className="input-label" style={{color: 'var(--primary)'}}>{t(`cat_${cat}`)}</label>
                  <input type="text" value={answers[cat]} onChange={(e) => setAnswers(prev => ({...prev, [cat]: e.target.value}))} className="input-field" placeholder={`${revealedLetter}...`} autoComplete="off" />
                </motion.div>
              ))}
              <motion.button whileTap={{ scale: 0.95 }} onClick={() => { ws.current.send(JSON.stringify({ type: 'submit_answers', data: { answers: answersRef.current } })); setHasSubmitted(true); }} className="btn btn-success btn-full" style={{gridColumn: '1 / -1', marginTop: '30px', padding: '20px', fontSize: '1.5rem'}}>{t('submitBtn')}</motion.button>
            </div>
          ) : (
            <motion.div initial={{ scale: 0.8 }} animate={{ scale: 1 }} className="card center-screen" style={{minHeight: '40vh', marginTop: '30px'}}>
              <motion.div animate={{ rotate: 360 }} transition={{ type: "spring", duration: 1 }} style={{background: 'var(--success)', borderRadius: '50%', padding: '20px', marginBottom: '20px', border: 'var(--border-thick)', boxShadow: '4px 4px 0px var(--shadow-color)'}}>
                <ShieldAlert size={60} color="#000" />
              </motion.div>
              <h2 className="header-title">{t('locked')}</h2>
              <p style={{fontSize: '1.2rem', fontWeight: 800, color: 'var(--text-muted)', marginTop: '15px'}}>{t('waitingOthers')}</p>
              {isHost && <button onClick={() => ws.current.send(JSON.stringify({ type: 'force_results' }))} className="btn btn-secondary mt" style={{marginTop: '40px'}}>{t('forceEnd')}</button>}
            </motion.div>
          )}
        </div>
      )}

      {room.state === 'validating' && (
        <div className="container-wide">
          <div className="card validation-card">
            <h2 className="header-title validation-title">{t('validation_title')}</h2>
            <p className="validation-subtitle">{t('validation_subtitle')}</p>
            <div className="validation-progress">
              <strong>{t('validation_progress')}:</strong>{' '}
              {(validationProgress?.submittedPlayers || 0)}/{(validationProgress?.requiredPlayers || room.players.length)}
            </div>

            {!hasSubmittedValidation ? (
              <>
                {validationTargets.length === 0 ? (
                  <p className="validation-empty">{t('validation_no_answers')}</p>
                ) : (
                  <div className="validation-list">
                    {validationTargets.map((target) => (
                      <div key={target.id} className="validation-target">
                        <div className="validation-target-head">
                          <div className="player-info">
                            <PlayerAvatar picture={target.picture} name={target.name} />
                            <strong>{t('validation_for_player')} {target.name}</strong>
                            {target.isPro && <span className="chat-pro"><Crown size={12} /> PRO</span>}
                          </div>
                        </div>
                        <div className="validation-grid">
                          {target.entries.map((entry) => {
                            const vote = validationVotes?.[target.id]?.[entry.category];
                            return (
                              <div key={`${target.id}-${entry.category}`} className="validation-entry">
                                <label className="input-label">{t(`cat_${entry.category}`)}</label>
                                <div className="validation-answer">{entry.answer}</div>
                                <div className="validation-actions">
                                  <button
                                    type="button"
                                    className={`validation-toggle valid ${vote === true ? 'active' : ''}`}
                                    onClick={() => updateValidationVote(target.id, entry.category, true)}
                                  >
                                    {t('validation_valid')}
                                  </button>
                                  <button
                                    type="button"
                                    className={`validation-toggle invalid ${vote === false ? 'active' : ''}`}
                                    onClick={() => updateValidationVote(target.id, entry.category, false)}
                                  >
                                    {t('validation_invalid')}
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <button
                  type="button"
                  className="btn btn-success btn-full"
                  onClick={submitValidation}
                  disabled={!isValidationReadyToSubmit}
                >
                  {t('validation_submit')} ({totalValidationDone}/{totalValidationRequired})
                </button>
                {isHost && (
                  <button
                    type="button"
                    onClick={() => ws.current.send(JSON.stringify({ type: 'force_results' }))}
                    className="btn btn-secondary mt"
                    style={{ marginTop: '16px' }}
                  >
                    {t('forceEnd')}
                  </button>
                )}
              </>
            ) : (
              <div className="validation-waiting">
                <h2 className="header-title">{t('locked')}</h2>
                <p>{t('validation_waiting')}</p>
                {pendingValidationNames.length > 0 && (
                  <p className="validation-pending-list">
                    {pendingValidationNames.join(', ')} ({t('validation_pending')})
                  </p>
                )}
                {isHost && (
                  <button
                    type="button"
                    onClick={() => ws.current.send(JSON.stringify({ type: 'force_results' }))}
                    className="btn btn-secondary mt"
                    style={{ marginTop: '20px' }}
                  >
                    {t('forceEnd')}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {room.state === 'results' && (
        <div className="container-wide">
          <h2 className="title" style={{marginBottom: '40px'}}>{t('results')}: {revealedLetter}</h2>
          <ResultsReveal room={room} isHost={isHost} nextRound={() => ws.current.send(JSON.stringify({ type: 'next_round' }))} t={t} />
        </div>
      )}

      {room.state === 'end' && <GameEndScreen room={room} t={t} />}
    </>
  );
}

export default App;
